import React from 'react';

const IconButton: React.FC<{
  onClick: () => void;
  children: React.ReactNode;
  color?: string;
  ariaLabel: string;
}> = ({ onClick, children, color, ariaLabel }) => (
  <button
    type='button'
    onClick={onClick}
    aria-label={ariaLabel}
    style={{
      cursor: 'pointer',
      display: 'inline-flex',
      alignItems: 'center',
      padding: 4,
      color,
      background: 'transparent',
      border: 0,
    }}
  >
    {children}
  </button>
);

export default IconButton;
